import { WaterfallStructure } from 'further-types/lp/carry-settings';

export const waterfallStructureLabels = {
  [WaterfallStructure.ReturnOfCapital]: 'Return of capital',
  [WaterfallStructure.PreferredReturn]: 'Preferred return',
  [WaterfallStructure.CarriedInterestPartnerCatchup]:
    'Carried interest partner catch-up',
  [WaterfallStructure.ExcessProceeds]: 'Excess proceeds',
};
